import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69bbff187d947e0014a425ca_1788856404092_b9418003/yagnick/src/app/priests/page.tsx");
